import { PAGINATION_ORDER } from 'shared/constants'
import { CommentSortEnum, CommentSortOptions } from 'modules/comments/types'

export const getDefaultSortOption = (isCommunityComments: boolean): CommentSortEnum => {
  return isCommunityComments ? CommentSortOptions.OLDEST_FIRST : CommentSortOptions.NEWEST_FIRST
}

export const getCommentSortParams = (
  sortOption: CommentSortEnum,
): {
  sortBy: string
  sortOrder: 'desc' | 'asc'
} => {
  const sortOrderForAPI = isOldestFirst(sortOption) ? PAGINATION_ORDER.ASC : PAGINATION_ORDER.DESC

  return {
    sortBy: isPopularSort(sortOption) ? 'popularity' : 'id',
    sortOrder: isPopularSort(sortOption) ? PAGINATION_ORDER.DESC : sortOrderForAPI,
  }
}

export const isNewestFirst = (sortOption: CommentSortEnum): boolean => {
  return sortOption === CommentSortOptions.NEWEST_FIRST
}

export const isOldestFirst = (sortOption: CommentSortEnum): boolean => {
  return sortOption === CommentSortOptions.OLDEST_FIRST
}

export const isPopularSort = (sortOption: CommentSortEnum): boolean => {
  return sortOption === CommentSortOptions.POPULAR
}
